import { render } from "./ImageDeployInstanceButton.vue?vue&type=template&id=62fb57e7"
import script from "./ImageDeployInstanceButton.vue?vue&type=script&lang=js"
export * from "./ImageDeployInstanceButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__